import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

function SiteFooter() {
  return (
    <div class="row  overlayfooter">
			<div class="row">

				{/* <!-- About --> */}
				<div class="col-lg-4 footer_col">
					<div class="footer_about">
						<div class="logo_container" >
							<a href="#">
								<div class="logo_content d-flex flex-row align-items-end justify-content-start">
									<div class="logo_img">
										{/* <img src="./images/spst-home-icon.png" alt="logo" className="footerimage"/> */}
										
										</div>
									{/* <div class="logo_text">Padmanabhaswami Temple </div> */}
								</div>
							</a>
						</div>
						<div class="clear" >
							<p className="foottest">തിരുവനന്തപുരം: തലസ്ഥാനത്തെ ഒരു പ്രധാന സദ്സംഗ കേന്ദ്രമാണ് അഭേദാശ്രമം. ഇവിടുത്തെ അഖണ്ഡനാമ വേദിയും നാമജപവും മനുഷ്യരാശിക്കാകെ ഭക്തിയും ശാന്തിയും,സുഖവും പ്രദാനം ചെയ്യുന്ന ഒരു മഹായജ്ഞ വേദിയാണ്. </p>
						</div>
						<div class="footer_social">
							<ul>
								<li><a href="#"><i class="fa fa-google-plus" aria-hidden="true"></i></a></li>
								<li><a href="#"><i class="fa fa-pinterest" aria-hidden="true"></i></a></li>
								<li><a href="#"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
								<li><a href="#"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
							</ul>
						</div>
						
					</div>
				</div>

				<div class="col-lg-2 footer_col">
					<div class="footer_links">
						<div class="footer_title">Quick menu</div>
						<ul className="footer_list">
							<li><Link to="/">Home</Link></li>
							<li><Link to="/Timing">Akhanda Namajapam</Link></li>
							<li><Link to="/">Gurudev</Link></li>
							<li><Link to="/">Arayoor</Link></li>
						</ul>
					</div>
				</div>

				<div class="col-lg-2 footer_col">
					<div class="footer_links">
						<div class="footer_title">Useful Links</div>
						<ul class="footer_list">
							<li><Link to="https://booking.abhedasramam.org/">Online Booking</Link></li>
							<li><Link to="Emagazine">e-Magazine</Link></li>
							<li><Link to="Gallery">Media Gallery </Link></li>
							<li><Link to="/">Activities</Link></li>
						</ul>
					</div>
				</div>

				<div class="col-lg-4 footer_col">
					<div class="footer_contact">
						<div class="footer_title">Contact Us</div>
						<div class="footer_contact_info">
							<div class="footer_contact_item">
								<div class="footer_contact_title orange">Address:</div>
								<div class="footer_contact_line">
									<p style={{color:'white',lineHeight:'15pt'}}>പരമ ഭട്ടാരക ശ്രീ ചട്ടമ്പി സ്വാമി സ്മാരക അഭേദശ്രമം മഹാമന്ത്രാലയം<br />
									സ്വാമി അഭേദാനന്ദ റോഡ്, ഫോർട്ട്, <br />
									തിരുവനന്തപുരം - 23</p>
								</div>
							</div>
							<div class="footer_contact_item">
								<div class="footer_contact_title orange">Phone:</div>
								<div class="footer_contact_line white">0471 - 2450519, 91 701211938</div>
							</div>
							{/* <div class="footer_contact_item">
								<div class="footer_contact_title orange">Email:</div>
								<div class="footer_contact_line white">catoeospst@gmail.com</div>
							</div> */}
						</div>
					</div>
				</div>
				<div className="copyrightbottom">
					<div class="row">
						<div class="col-md-8">
							<div class="copyrighttext">
								<p class="foottest" style={{lineHeight:'20px'}}>Copyright © 2025 Sree Padmanabhaswamy Temple (SPST), All Rights Reserved.  <br/> <Link to="/">Terms & Conditions </Link> Enabled by Kshethrasuvidham Temple Management Solutions.</p>
							</div>
						</div>
						<div class="col-md-4">
							<div className="footerlogo">
								<img src="./images/kshethrasuvidhamLogo.jpg" style={{width:'50%'}} />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div style={{width:'100px',height:'100px',position:'fixed',zIndex:'9',bottom:'0',right:'0',marginRight:'85px',marginBottom:'10px'}}>
				<img src="./images/balakrishna-temple.png" alt="Balakrishna_Temple" style={{width:'100%'}} />
			</div>
		</div>
  );
}

export default SiteFooter;

